var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"lds-dual-ring"}),_vm._v(" "),_c('div',{staticClass:"lds-dual-ring-reverse"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }